import { DocumentViewer } from '@enter/core';
import { mdiClose } from '@mdi/js';
import React, { useContext } from 'react';
import { DialogContext, IDialogContextProps } from '../../services';
import * as S from './document.styles';

export function useDocumentView() {
    const dialogContext = useContext(DialogContext) as IDialogContextProps;

    const handleCloseDialog = (): void => {
        dialogContext.hideDialog?.();
    };

    function openFile(url: string, title: string = 'Document') {
        const dialogProps = {
            onClose: handleCloseDialog,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            renderTitle: title,
            // Set z-index higher than messaging panel (1301) to ensure document viewer appears above it
            style: { zIndex: 1400 },
        };

        dialogContext.showDialog?.({
            props: dialogProps,
            Component: (
                <S.Wrapper>
                    <S.CloseButton variant="fab-light" onClick={handleCloseDialog}>
                        <S.CloseIcon path={mdiClose} size={1} />
                    </S.CloseButton>
                    <DocumentViewer url={url} />
                </S.Wrapper>
            ),
        });
    }

    return [openFile];
}
